import React,{useState,useEffect} from 'react'
import style from './styles.module.css'
import Viewer from 'react-viewer'
import _ from 'lodash';

export const CommentImages = (props) => {
    const showData = props.showData;
  const [ visible, setVisible ] = React.useState(false);

  useEffect(() => {
  },[showData]);
  return (
      <div>
        <Viewer visible={visible} onClose={() => { setVisible(false); }} images={showData} />
        <div className={style.listFileImage}>
            { showData.map((value,index) =>
                <div key={index} className={style.fileImage}><img onClick={() => {setVisible(true)}} src={value.src}/><a onClick={(src) => props.removeImage(value.src)} className={style.btnClose}>x</a></div>
            )}
        </div>
      </div>
  );
}